import React, { useState } from "react";
import "../InquiryForm.css"; // Use the same styling as before
import Navbar from "../../Navbar";

function CorporateInquiry() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    companyName: "",
    position: "",
    message: "",
    recaptcha: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleRecaptcha = (e) => {
    setFormData({ ...formData, recaptcha: e.target.checked });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.recaptcha) {
      alert("Please complete the reCAPTCHA");
      return;
    }
    console.log("Corporate Inquiry Submitted:", formData);
  };

  return (
    <>
      <Navbar />
      <div className="form-container">
        <h1>CORPORATE INQUIRY</h1>
        <form onSubmit={handleSubmit} className="inquiry-form">
          <h2>Corporate Inquiry Form</h2>
          <label>
            First Name*
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            Last Name*
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            Email*
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            Phone*
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            Company Name*
            <input
              type="text"
              name="companyName"
              value={formData.companyName}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            Position*
            <input
              type="text"
              name="position"
              value={formData.position}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            Message*
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </label>
          
          <button type="submit" className="submit-button">
            Submit
          </button>
        </form>
      </div>
    </>
  );
}

export default CorporateInquiry;
